import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'sku.availability-modal.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'sku.availability-modal.continue',
    defaultMessage: 'Continue',
  },
  titleSingleItem: {
    id: 'sku.availability-modal.title-single-item',
    defaultMessage: 'Mark {itemName} unavailable',
  },
  titleMultiItem: {
    id: 'sku.availability-modal.title-multi-item',
    defaultMessage: 'Edit {itemName} availability',
  },
  introSingleItem: {
    id: 'sku.availability-modal.intro-single-item',
    defaultMessage:
      'This is the only item in the order, so the order will be cancelled with no payout and the customer will be notified.',
  },
  introMultiItem: {
    id: 'sku.availability-modal.intro-multi-item',
    defaultMessage:
      "We'll remove this item from your order and update its availability based on your selection. Customers will not be able to order it for at least the rest of day. We'll notify customers of the order update.",
  },
  unavailableTodayDescription: {
    id: 'sku.availability-modal.unavailable-today-option-description',
    defaultMessage: 'Automatically goes back in stock again tomorrow',
  },
  unavailableIndefinitelyDescription: {
    id: 'sku.availability-modal.unavailable-indefinitely-option-description',
    defaultMessage: 'Stays out of stock until you make it available again',
  },
});
